type EventName =
  | 'AddPaymentInfo'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'ClickButton'
  | 'CompletePayment'
  | 'CompleteRegistration'
  | 'Contact'
  | 'Download'
  | 'InitiateCheckout'
  | 'PlaceAnOrder'
  | 'Search'
  | 'SubmitForm'
  | 'Subscribe'
  | 'ViewContent';

export const tikTokEvent = (
  name: EventName,
  options?: { [key: string]: any },
) => {
  // @ts-ignore

  window.ttq?.track(name, options);
};

export const tikTokAdvancedMatching = (email: string) => {
  // @ts-ignore

  window.ttq?.identify({
    email: email,
  });
};
